import { memo, FC } from 'react';

import clsx from 'clsx';
import { useStyles } from './style';

interface Props {
  description: string | null;
  name: string | null;
  email: string | null;
  imgSrc?: string | null;
  phone: string | null;
  emergencyPhone: string | null;
  role: string | null;
}

const Card: FC<Props> = ({
  description,
  name,
  email,
  imgSrc,
  phone,
  role,
  emergencyPhone,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div
        className={classes.contentBox}
        style={{ maxWidth: imgSrc ? '50%' : '100%' }}
      >
        {name && (
          <h3
            className={clsx(classes.name, {
              [classes.nameOffset]: !role,
            })}
          >
            {name}
          </h3>
        )}
        {role && <span className={classes.role}>{role}</span>}
        {email && (
          <a
            className={clsx(classes.link, classes.mail)}
            href={`mailto:${email}`}
          >
            <input
              className={classes.input}
              defaultValue={`${email}`}
              disabled
            />
          </a>
        )}
        {phone && (
          <a className={classes.link} href={`tel:${phone}`}>
            <input
              className={classes.input}
              defaultValue={`${phone}`}
              disabled
            />
          </a>
        )}
        {emergencyPhone && (
          <a
            className={clsx(classes.link, classes.emergency)}
            href={`tel:${emergencyPhone}`}
          >
            <input
              className={classes.input}
              defaultValue={`${emergencyPhone} päivystys`}
              disabled
            />
          </a>
        )}
        {description && <p className={classes.description}>{description}</p>}
      </div>
      {imgSrc ? (
        <img
          className={classes.photo}
          src={`data:image/png;base64,${imgSrc}`}
          alt={name || ''}
        />
      ) : null}
    </div>
  );
};

export default memo(Card);
